// extracted by mini-css-extract-plugin
var _1 = "IfnIjUW9g3Nv4C8Kr55y";
var _2 = "aB8L3WsoQ_tqSAh0Crwk";
export { _1 as "options", _2 as "pannel" }
